// extracted by mini-css-extract-plugin
export default {"footer":"DownloadReportModal_footer__iCGXZ","body":"DownloadReportModal_body__3Pv40"};